import React from "react";
import { DataGrid } from "@mui/x-data-grid";

const parameters = {
  price: "Price",
  numberOfAssets: "Number of Assets",
  scanFrequency: "Scan Frequency",
  securityPosture: "Security Posture",
  securityPostureReport: "Security Posture Report",
  supportResponse: "Support Response",
  costInsight: "Cost Insight",
  eventInsight: "Event Insight",
  costOptimization: "Cost Optimization",
  name: "name",
  // iaac: "IaaC",
};

const transposeData = (data) => {
  // get all keys: id, price, numberOfAssets, securityPosture, securityPostureReport
  const keys = Object.keys(data[0]);
  // get all plan names: Basic, Standard, ...
  // let planNames = data.map( plan => plan.name.startsWith("CUS") ? plan.description : plan.name);
  let planNames = data.map((plan) => plan.name);

  console.log("Plan names: ", planNames);
  const transposedData = [];

  // For each key, create a row with properties as id, Basic, Standard, ... all plans
  for (const key of keys) {
    if (key === "id") {
      continue;
    }
    let row = { id: parameters[key] };
    // For each plan, store value of current property
    planNames.forEach((planName) => {
      const matchingPlanForPlanName = data.find(
        (plan) => plan.name === planName
      );
      // console.log(" matchingPlanForPlanName: ", matchingPlanForPlanName);
      if (!matchingPlanForPlanName) {
        row = { ...row, [planName]: "Contact Us" };
      } else {
        row = { ...row, [planName]: matchingPlanForPlanName[key] };
      }
    });
    transposedData.push(row);
  }
  return transposedData;
};

const GlobalLicense = (props) => {
  console.log("Props :: ", props);
  const globalLicenseData = props.license["Subscription Model"];
  let rows = globalLicenseData.map((plan, index) => {
    const name = plan["Name"];
    const metrics = plan;
    const metrickeys = Object.keys(metrics);

    return {
      id: index + 1,
      name: name,
      price: metrics["Price"],
      numberOfAssets: metrics["Number Of Assets"],
      scanFrequency: metrics["Scan Frequency"],
      securityPosture: metrics["Security Posture"],
      securityPostureReport: metrics["Security Posture Report"],
      supportResponse: metrics["Support Response"],
      eventInsight:
        metrics["Add ons"] === null || metrics["Add ons"].length === 0
          ? -1
          : metrics["Add ons"]?.find(
              (addOns) => addOns.Name === "Event Insight"
            )?.Price,
      costInsight:
        metrics["Add ons"] === null || metrics["Add ons"].length === 0
          ? -1
          : metrics["Add ons"]?.find((addOns) => addOns.Name === "Cost Insight")
              ?.Price,
      costOptimization:
        metrics["Add ons"] === null || metrics["Add ons"].length === 0
          ? -1
          : metrics["Add ons"]?.find(
              (addOns) => addOns.Name === "Cost Optimization"
            )?.Price,
      // iaac: (metrics["Add ons"]===null || metrics["Add ons"].length === 0)? -1: metrics["Add ons"]?.find(addOns => addOns.Name === "IaaC")?.Price,
    };
  });

  const planNames = rows.map((plan) => plan.name);

  rows = transposeData(rows);
  rows = rows.filter((row) => row.id !== "name");

  console.log("transposeData: ", rows);

  const idColumn = {
    field: "id",
    headerName: "",
    width: 180,
    minWidth: 180,
    flex: 1,
    sortable: false,
    renderCell: (rowData) => {
      // if (rowData.row.id === "enabled") {
      //   return null;
      // }
      if (rowData.row.id === "Price") {
        return (
          <>
            Price (<small style={{ color: "red" }}>Billed Monthly</small>)
          </>
        );
      }
    },
  };

  const dynamicColumns = planNames.map((planName, index) => {
    return {
      field: planName,
      headerName: planName,
      width: 200,
      sortable: false,
      renderCell: (rowData) => {
        // console.log("dynamicColumn rowData =", rowData);
        if (rowData.row.id === "Price") {
          return "$ " + rowData.row[planName];
        }
        if (
          ["Event Insight", "Cost Insight", "Cost Optimization"].includes(
            rowData.row.id
          )
        ) {
          if (rowData.row[planName] < 0) {
            return "Not Available";
          } else {
            return "$ " + rowData.row[planName];
          }
        }
      },
      disableClickEventBubbling: true,
      align: "center",
      headerAlign: "center",
    };
  });

  const defaultEnterpriseColumn = {
    field: "enterprise",
    headerName: "Enterprise",
    width: 140,
    sortable: false,
    renderCell: (rowData) => {
      if (rowData.row.id === "enabled") {
        return null;
      } else {
        return "Contact Us";
      }
    },
    disableClickEventBubbling: true,
    align: "center",
    headerAlign: "center",
  };

  const columns = [
    { ...idColumn },
    ...dynamicColumns,
    { ...defaultEnterpriseColumn },
  ];

  return (
    <div>
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <DataGrid
          getRowId={(row) => row.id}
          rows={rows}
          columns={columns}
          pageSize={5}
          disableSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          disableColumnSelector
          disableDensitySelector
          disableColumnReorder
          disableMultipleColumnsSorting
          disableMultipleColumnsFiltering
          hideFooterPagination
          autoHeight
          hideFooter
          rowHeight={40}
        />
      </div>
    </div>
  );
};

export default GlobalLicense;
